import { HeaderProvider } from '@/sinister/header/contexts/HeaderContext'
import { HeaderProps } from '@/sinister/header/entities/header'
import { FC } from 'react'
import { DesktopFactory, MobileFactory } from './factory'

const HeaderContent: FC<{ isMobile: boolean }> = ({ isMobile }) => {
  return isMobile ? MobileFactory['A'] : DesktopFactory['A']
}

const Header: FC<HeaderProps> = (props) => {
  return (
    <HeaderProvider {...props}>
      <HeaderContent isMobile={props.isMobile || false} />
    </HeaderProvider>
  )
}

export default Header
